import { Box } from '@rocket/ui';
import { diffWords } from 'diff';

interface SentenceDiffProps {
  before: string;
  after: string;
}

export function SentenceDiff({ before, after }: SentenceDiffProps) {
  const isDelete = after === '[removed]' || after.trim() === '';

  if (isDelete) {
    return (
      <Box
        my="1.5"
        px="2.5"
        py="1.5"
        bg="red.subtle"
        borderWidth="1px"
        borderColor="red.muted"
        borderRadius="md"
        fontSize="xs"
        lineHeight="1.6"
      >
        <Box
          as="span"
          bg="red.muted"
          color="red.fg"
          textDecoration="line-through"
          borderRadius="sm"
          px="0.5"
        >
          {before}
        </Box>
      </Box>
    );
  }

  const changes = diffWords(before, after);

  return (
    <Box
      my="1.5"
      px="2.5"
      py="1.5"
      bg="bg.subtle"
      borderWidth="1px"
      borderColor="border"
      borderRadius="md"
      fontSize="xs"
      lineHeight="1.6"
    >
      {changes.map((change: (typeof changes)[number], index: number) => {
        if (!change.added && !change.removed) {
          return <span key={index}>{change.value}</span>;
        }

        if (change.removed) {
          return (
            <Box
              as="span"
              key={index}
              bg="red.muted"
              color="red.fg"
              textDecoration="line-through"
              borderRadius="sm"
              px="0.5"
            >
              {change.value}
            </Box>
          );
        }

        if (change.added) {
          return (
            <Box as="span" key={index} bg="green.muted" color="green.fg" borderRadius="sm" px="0.5">
              {change.value}
            </Box>
          );
        }

        return null;
      })}
    </Box>
  );
}
